import React from 'react';
import { TripMatchStatus } from '@marageti/z4-sdk/lib/travel';
import SoldTripsView from './sold-view';
import { sortByValuesSoldTrips } from '../options';
import useTripMatchSearch from '../../../hooks/use-trip-match-search';
import useURLSearchQuery from '../../../hooks/use-url-for-search-query';

interface DefaultSearch {
  [key: string]: string | string[];
  countries: string[];
  fullText: string;
  order: string;
  partner: string;
  refineSold: string[];
  sort: string;
}

const defaultSearch: DefaultSearch = {
  countries: [],
  fullText: '',
  order: sortByValuesSoldTrips.returnDate.order,
  partner: 'all',
  refineSold: [],
  sort: sortByValuesSoldTrips.returnDate.field,
  status: [TripMatchStatus.MatchSold],
};

const SoldTripsContainer = () => {
  const [queryValues, updateURLQuery] = useURLSearchQuery<DefaultSearch>(defaultSearch);
  const {
    countries,
    fullText,
    partner,
    refineSold,
    sort,
  } = queryValues;

  const {
    tripMatches,
    error,
    hasMore,
    isLoading,
    loadMore,
    mutate,
    totalHits,
  } = useTripMatchSearch(
    {
      ...queryValues,
      sort: sortByValuesSoldTrips[queryValues.sort as keyof typeof sortByValuesSoldTrips].field,
    },
  );

  const onChangeFilter = (name: string, v: string | string[]) => {
    switch (name) {
      case 'partner':
        updateURLQuery({ partner: v });
        break;
      case 'sort': {
        updateURLQuery({
          sort: v,
          order: sortByValuesSoldTrips[v as keyof typeof sortByValuesSoldTrips].order,
        });
        break;
      }
      case 'countries':
        updateURLQuery({ countries: v });
        break;
      case 'fullText':
        updateURLQuery({ fullText: v });
        break;
      case 'refineSold':
        if (Array.isArray(v)) {
          // Only one chip can be selected at a time
          const filtered = v.filter((val) => !refineSold.includes(val));
          updateURLQuery({ refineSold: filtered });
        }
        break;
      default:
        break;
    }
  };

  const formattedTMCount = new Intl.NumberFormat('en-US').format(totalHits);

  return (
    <SoldTripsView
      countries={countries}
      disableSortBy={fullText.length > 0}
      error={error}
      hasMoreItems={hasMore}
      isLoading={isLoading}
      items={tripMatches}
      loadMore={loadMore}
      onChangeFilter={onChangeFilter}
      onRefreshResults={mutate}
      partner={partner}
      refineSold={refineSold}
      searchValue={fullText}
      sortBy={sort}
      totalHits={formattedTMCount}
    />
  );
};

export default SoldTripsContainer;
